import hasBillesAccess from 'utils/hasBillesAccess'
import setCompanies from '../helpers/setCompanies'

function setUsers({ input, state }) {
  let clientHelper = state.get('client.helper.admin.user')
  let users = input.result.reduce((acc, user) => {
    let access = null
    if (user.clients.modules) {
      access = user.clients.modules.reduce((acc, module) => {
        if (module.module === 'account') {
          acc = module.access
        }
        return acc
      }, access)
    }
    if (
      !(
        clientHelper.isAdmin &&
        !clientHelper.isBilles &&
        hasBillesAccess(access)
      )
    ) {
      let companies = []
      setCompanies(companies, user.clients.visiting)
      setCompanies(companies, user.clients.delivery)
      setCompanies(companies, user.clients.invoice)
      const { modules = [] } = user.clients
      acc.push({
        _id: user._id,
        lastname: user.lastname,
        firstname: user.firstname,
        email: user.email,
        lastLogin: user.clients.lastLogin,
        validFrom: user.clients.validFrom,
        validTo: user.clients.validTo,
        companies: companies,
        access: access,
        modules: modules.reduce((acc, item) => {
          acc[item.module] = item.group
          return acc
        }, {})
      })
    }
    return acc
  }, [])
  state.set('users.approved', users)
}

export default setUsers



// WEBPACK FOOTER //
// ./src/modules/user/actions/setUsers.js